<div class="header-profile-content px-3">
	<div class="pt-2 userName" [title]="userName">{{ userName }}</div>
	<div class="pb-4 userEmail" [title]="userEmail">{{ userEmail }}</div>
	<div class="grey-text text-darken-3 m-0 d-flex align-items-center cursor-pointer userProfileAction" (click)="onProfileClick()">
		<i class="mdi-action-face-unlock pr-2" style="font-size: 1.6rem;"></i>
		<span class="pt-1">Profil</span>
	</div>
	<div class="grey-text text-darken-3 m-0 d-flex align-items-center cursor-pointer userProfileAction" (click)="onHelpClick()">
		<i class="mdi-action-help pr-2" style="font-size: 1.6rem;"></i>
		<span class="pt-1">Ajutor</span>
	</div>
	<div class="grey-text text-darken-3 m-0 d-flex align-items-center cursor-pointer userProfileAction" (click)="onLogoutClick()">
		<i class="mdi-hardware-keyboard-tab pr-2" style="font-size: 1.6rem;"></i>
		<span class="pt-1">Ieșire</span>
	</div>
</div>
